import { FetcherJSONResponse } from 'services/fetcher';
import { Project } from './types';

export function deserializeProject(data: FetcherJSONResponse) {
  return { ...data, createdAt: new Date(data.createdAt as string) } as Project;
}
